module.exports = __webpack_public_path__ + "static/media/BI.520d354d.webp";